import { render, staticRenderFns } from "./filingList.vue?vue&type=template&id=b2315c0e&scoped=true"
import script from "./filingList.vue?vue&type=script&lang=js"
export * from "./filingList.vue?vue&type=script&lang=js"
import style0 from "./filingList.vue?vue&type=style&index=0&id=b2315c0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2315c0e",
  null
  
)

export default component.exports